export default {
      id: "icon--deals-usage",
      viewBox: "0 0 24.4 24.4",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--deals-usage",
      toString: function () {
        return this.url;
      }
    }